module.exports = [{"name":"Sobre nós","url":"#","to":"about"},{"name":"Blog","url":"#","to":"blog"},{"name":"Integrações","url":"#","to":"clients"}]


//////////////////
// WEBPACK FOOTER
// ./src/database/company_links.json
// module id = xhJS
// module chunks = 0